const awsmobile = {
  "aws_appsync_region": "ap-southeast-2",
  "aws_appsync_authenticationType": "API_KEY",
  "aws_appsync_graphqlEndpoint": "https://x4v5mokeqbbz3fzr4zgrlxxh6m.appsync-api.ap-southeast-2.amazonaws.com/graphql",
  "aws_appsync_apiKey": "da2-dx7oswmi3nc6vddit3drw5jhni"
};

export default awsmobile;
